export default __webpack_public_path__ + "static/media/cotton.f22d653a.svg";